module.exports = __webpack_public_path__ + "img/default-user-avatar.4162ac19.png";